import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import StickyMobileCTA from "./StickyMobileCTA";

export default function Layout() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }, [pathname]);

    return (
        <div className="App">
            <Header />
            <main className="pt-[72px]">
                <Outlet />
            </main>
            <Footer />
            <StickyMobileCTA />
            {/* spacer to prevent sticky bottom bar overlap on mobile */}
            <div aria-hidden className="lg:hidden h-[78px]" />
        </div>
    );
}
